// @ts-strict-ignore
import Image from 'next/image'
import Link from 'next/link'

import { getBotInfo } from '@/shared/lib/seo'
import { ElementsSliderFree } from '@/shared/ui/elements-slider-free'

import cl from './FiltredCategories.module.scss'

export const FilteredCategories = ({ data }) => {
	const isBot = getBotInfo('isDetected')

	return (
		<ElementsSliderFree classNameSlide={cl.slide}>
			{data.map(item => (
				<Link href={item.link} key={item.code} prefetch={false}>
					<div className={cl.category} title={`Категория ${item.title}`}>
						<div className={cl.image}>
							<Image
								src={item.imgSrc}
								priority={isBot}
								quality={100}
								width={120}
								height={120}
								alt={`Категория ${item.title}`}
							/>
						</div>
						<p>{item.title}</p>
					</div>
				</Link>
			))}
		</ElementsSliderFree>
	)
}
